export const handleApiError = (error, defaultMessage) => {
  // Handle different types of errors more robustly
  let errorMessage = defaultMessage;

  try {
    if (error?.response?.data) {
      const responseData = error.response.data;
      
      // Check for different error message formats
      if (typeof responseData === 'string') {
        errorMessage = responseData;
      } else if (responseData.detail) {
        errorMessage = responseData.detail;
      } else if (responseData.error) {
        errorMessage = responseData.error;
      } else if (responseData.message) {
        errorMessage = responseData.message;
      } else if (responseData.errors) {
        // Handle validation errors array
        if (Array.isArray(responseData.errors)) {
          errorMessage = responseData.errors.join(', ');
        } else if (typeof responseData.errors === 'object') {
          const errorMessages = Object.values(responseData.errors)
            .flat()
            .filter(msg => typeof msg === 'string');
          errorMessage = errorMessages.length > 0 ? errorMessages.join(', ') : defaultMessage;
        }
      }
    } else if (error?.message) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    }
  } catch (parseError) {
    console.error('Error parsing API error:', parseError);
    errorMessage = defaultMessage;
  }

  return errorMessage;
};

export const logError = (context, error, additionalData = {}) => {
  const errorLog = {
    context,
    error: {
      message: error?.message,
      status: error?.response?.status,
      data: error?.response?.data,
      stack: error?.stack,
    },
    timestamp: new Date().toISOString(),
    ...additionalData,
  };

  // In development, log to console
  if (process.env.NODE_ENV === 'development') {
    console.error(`[${context}] Error:`, errorLog);
  }

  // In production, you might want to send to a logging service
  // Example: logToService(errorLog);
};

export const isNetworkError = (error) => {
  return !error?.response && error?.request;
};

export const isTimeoutError = (error) => {
  return error?.code === 'ECONNABORTED' || error?.message?.includes('timeout');
};

export const isServerError = (error) => {
  return error?.response?.status >= 500;
};

export const isClientError = (error) => {
  return error?.response?.status >= 400 && error?.response?.status < 500;
};